module.exports = __WEBPACK_EXTERNAL_MODULE_11__;


//////////////////
// WEBPACK FOOTER
// external "rxjs/add/operator/catch"
// module id = 11
// module chunks = 0